"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiamsMobile = exports.TnaMobile = exports.ThaMobile = exports.RiamsWeb = exports.TnaWeb = exports.ThaWeb = void 0;
var RiamsWeb = require("./riams");
exports.RiamsWeb = RiamsWeb;
var TnaWeb = require("./tna");
exports.TnaWeb = TnaWeb;
var ThaWeb = require("./tha");
exports.ThaWeb = ThaWeb;
var RiamsMobile = require("./riams-mobile");
exports.RiamsMobile = RiamsMobile;
var TnaMobile = require("./tna-mobile");
exports.TnaMobile = TnaMobile;
var ThaMobile = require("./tha-mobile");
exports.ThaMobile = ThaMobile;
